import {forwardRef, MouseEventHandler, ReactNode} from 'react';
import {InputContainer, InputWrap, Title} from './RoundInput.styled';
import { useI18n } from '@i18n/useI18n';

export interface IRoundInput {
  children: ReactNode;
  className?: string;
  title?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const RoundInput = forwardRef<HTMLDivElement, IRoundInput>(({ children, className, title, onClick }: IRoundInput, ref) => {
  const i18n = useI18n();

  return (
    <InputWrap className={className} onClick={onClick} ref={ref}>
      {title && <Title>{i18n.t(title)}:</Title>}
      <InputContainer>{children}</InputContainer>
    </InputWrap>
  );
});

export default RoundInput;
